import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { NgModule } from '@angular/core';
import { RxIconComponent } from './rx-icon.component';

@NgModule({
  imports: [CommonModule, MatIconModule, RxIconComponent],
  exports: [RxIconComponent],
})
export class RxIconModule {}
